export const DEFAULT_SPACING = 4;
export const THREE_QUARTER_SPACING = 3;
export const HALF_SPACING = 2;
export const QUARTER_SPACING = 1;
export const SECTION_SPACING = DEFAULT_SPACING * 2;
export const DEFAULT_MARGIN_BOTTOM = "8px !important";
export const DEFAULT_MARGIN_TOP = "0 !important";
export const COMPACT_ROW_PADDING = {
  paddingTop: HALF_SPACING,
  paddingBottom: HALF_SPACING,
  paddingLeft: DEFAULT_SPACING,
  paddingRight: DEFAULT_SPACING
};
